import { IPagination } from 'app/types/common';

export interface IBulkMatchPaymentsState {
  readonly bulkMatchPaymentsById?: any;
  readonly bulkMatchPaymentIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddBulkMatchPayment?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationBulkMatchPaymentIds?: string[];
  readonly currentBulkMatchPaymentId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IBulkMatchPaymentsSelector extends IBulkMatchPaymentsState {
  readonly currentBulkMatchPayment?: any;
  readonly currentFormBulkMatchPayment?: any;
  readonly getBulkMatchPaymentsFilteredByTagInSelectFormat?: any;
  readonly bulkMatchPaymentsByIdInSelectFormat?: any;
}

export enum BulkMatchPaymentsActionTypes {
  GET_ALL_BULK_MATCH_PAYMENTS_REQUESTED = 'redux-app/bulk-match-payments/GET_ALL_BULK_MATCH_PAYMENTS_REQUESTED',
  GET_ALL_BULK_MATCH_PAYMENTS_PENDING = 'redux-app/bulk-match-payments/GET_ALL_BULK_MATCH_PAYMENTS_PENDING',
  GET_ALL_BULK_MATCH_PAYMENTS_SUCCESS = 'redux-app/bulk-match-payments/GET_ALL_BULK_MATCH_PAYMENTS_SUCCESS',
  GET_ALL_BULK_MATCH_PAYMENTS_FAIL = 'redux-app/bulk-match-payments/GET_ALL_BULK_MATCH_PAYMENTS_FAIL',
  GET_BULK_MATCH_PAYMENT_REQUESTED = 'redux-app/bulk-match-payments/GET_BULK_MATCH_PAYMENT_REQUESTED',
  GET_BULK_MATCH_PAYMENT_PENDING = 'redux-app/bulk-match-payments/GET_BULK_MATCH_PAYMENT_PENDING',
  GET_BULK_MATCH_PAYMENT_SUCCESS = 'redux-app/bulk-match-payments/GET_BULK_MATCH_PAYMENT_SUCCESS',
  GET_BULK_MATCH_PAYMENT_FAIL = 'redux-app/bulk-match-payments/GET_BULK_MATCH_PAYMENT_FAIL',
  UPDATE_BULK_MATCH_PAYMENT_REQUESTED = 'redux-app/bulk-match-payments/UPDATE_BULK_MATCH_PAYMENT_REQUESTED',
  UPDATE_BULK_MATCH_PAYMENT_PENDING = 'redux-app/bulk-match-payments/UPDATE_BULK_MATCH_PAYMENT_PENDING',
  UPDATE_BULK_MATCH_PAYMENT_SUCCESS = 'redux-app/bulk-match-payments/UPDATE_BULK_MATCH_PAYMENT_SUCCESS',
  UPDATE_BULK_MATCH_PAYMENT_FAIL = 'redux-app/bulk-match-payments/UPDATE_BULK_MATCH_PAYMENT_FAIL',
  CREATE_BULK_MATCH_PAYMENT_REQUESTED = 'redux-app/bulk-match-payments/CREATE_BULK_MATCH_PAYMENT_REQUESTED',
  CREATE_BULK_MATCH_PAYMENT_PENDING = 'redux-app/bulk-match-payments/CREATE_BULK_MATCH_PAYMENT_PENDING',
  CREATE_BULK_MATCH_PAYMENT_SUCCESS = 'redux-app/bulk-match-payments/CREATE_BULK_MATCH_PAYMENT_SUCCESS',
  CREATE_BULK_MATCH_PAYMENT_FAIL = 'redux-app/bulk-match-payments/CREATE_BULK_MATCH_PAYMENT_FAIL',
  DELETE_BULK_MATCH_PAYMENT_REQUESTED = 'redux-app/bulk-match-payments/DELETE_BULK_MATCH_PAYMENT_REQUESTED',
  DELETE_BULK_MATCH_PAYMENT_PENDING = 'redux-app/bulk-match-payments/DELETE_BULK_MATCH_PAYMENT_PENDING',
  DELETE_BULK_MATCH_PAYMENT_SUCCESS = 'redux-app/bulk-match-payments/DELETE_BULK_MATCH_PAYMENT_SUCCESS',
  DELETE_BULK_MATCH_PAYMENT_FAIL = 'redux-app/bulk-match-payments/DELETE_BULK_MATCH_PAYMENT_FAIL',
  SELECT_BULK_MATCH_PAYMENT_REQUESTED = 'redux-app/bulk-match-payments/SELECT_BULK_MATCH_PAYMENT_REQUESTED',
}

export default null;
